import React from 'react';
import ReactDOM from 'react-dom/client';
import { SnackbarProvider } from 'notistack';
import { IconButton, Slide } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { BrowserRouter, BrowserRouter as Router } from 'react-router-dom';
import AppWrapper from './Appwraper';


const root = ReactDOM.createRoot(document.getElementById('root'));

const notiStackRef = React.createRef();
const onClickDismiss = (key) => () => {
 notiStackRef.current.closeSnackbar(key);
};
root.render(
 
  <BrowserRouter basename='/'>
     <SnackbarProvider
        hideIconVariant
        ref={notiStackRef}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        TransitionComponent={Slide}
        maxSnack={3}
        autoHideDuration={2000}
        action={(key) => (
          <IconButton onClick={onClickDismiss(key)}>
            <CloseIcon htmlColor='white' />
          </IconButton>
        )}
      >
      <AppWrapper />
      </SnackbarProvider>
  
  </BrowserRouter>

);
